"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOptedOut = exports.deriveOrderStatus = void 0;
/**
 * `now < cutoffAt` → EDITABLE (the weekly proposal, still open to changes);
 * `now >= cutoffAt` → CLOSED (final, will be exported; only returns may mutate it).
 */
const deriveOrderStatus = (order, now) => now.getTime() < order.cutoffAt.getTime() ? 'EDITABLE' : 'CLOSED';
exports.deriveOrderStatus = deriveOrderStatus;
/**
 * Every line at zero reads as "sin pedido" — there is no cancellation concept.
 * Only a store whose floor (`minQuantityPerProduct`) is 0 can write it; above
 * that it arrives from history or a staff correction. This presentation-only
 * helper labels the state; an order with no lines counts as opted out.
 */
const isOptedOut = (order) => order.products.every((line) => line.quantity === 0);
exports.isOptedOut = isOptedOut;
//# sourceMappingURL=derive-order-status.js.map